var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.isMiniProgram)?_c('router-view',{staticClass:"child-view"}):_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{staticClass:"child-view"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }